import React from "react";
import classNames from "classnames";

import Address from "../../Address";

import Employee from "../../../AvailableEvents/AvailableEmployees/Employee";

import styles from "./AppointmentEvent.css";
import ActionButtons from "./ActionButtons";
import Details from "./Details";

import { useDrop } from "react-dnd";

import moment from "moment";

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        borderColor: color,
      };

const AppointmentEvent = ({
  className,
  detailEnabled,
  entity,
  event,
  date,
  currentDate,
  locationEnabled,
  onClick,
  onOpenClick,
  onDeleteEventClick,
  onEditEventClick,
  onRescheduleRes,
  activeEquipment,
  showActions,
  styleSelector,
  mode,
}) => {
  const ondbClick = () => {
    let evtcrew = event.crew;
    if (evtcrew) {
      evtcrew.equipment = activeEquipment;
      onRescheduleRes(
        event.id,
        currentDate ? currentDate : moment().format(),
        evtcrew,
        mode
      );
    }
  };
  const [{ canDrop, isDragging, isOver }, drop] = useDrop({
    accept: ["employee", "crew"],

    canDrop: (item) => {
      switch (item.type) {
        case "employee":
          return true;
        case "crew":
          return true;
        default:
          return false;
      }
    },
    collect: (monitor) => ({
      canDrop: !!monitor.canDrop(),
      isDragging: !!monitor.getItem(),
      isOver: !!monitor.isOver(),
    }),
    drop: (item) => {
      switch (item.type) {
        case "employee":
          const rs = { resource: item.employee };
          let resources = [];
          if (event.crew != null) {
            const existing_resource = event.crew.resources.find(
              (r) => r.resource.id === rs.resource.id
            );
            resources = existing_resource
              ? event.crew.resources.slice()
              : event.crew.resources.concat([rs]);
          } else {
            resources.push(rs);
          }
          const res = { resources: resources };
          let crew = {};
          if (event.crew != null) {
            crew = Object.assign({}, event.crew, { resources });
          } else {
            crew.id = 0;
            crew.equipment = null;
            crew.resources = resources;
          }

          onRescheduleRes(event.id, event.endDate, crew, mode);
          break;
        case "crew":
          onRescheduleRes(event.id, event.endDate, item.standardcrew, mode);
          break;
        default:
          break;
      }
    },
  });

  let color = "#304e1e";
  let employeeCheck = "#FFF";

  let curdate = currentDate ? currentDate : moment();
  color = event.crew
    ? moment(curdate).isSame(date, "day")
      ? "#304e1e"
      : "#afd3aa"
    : "#afd3aa";
  let showEmployees = false;
  if (event.crew && event.crew.resources) {
    showEmployees = true;
  }

  return (
    <div
      className={classNames(className || styles.container, styles.tentative, {
        [styles.inactive]: entity !== "appointments",
      })}
      style={
        typeof styleSelector === "function"
          ? styleSelector(event)
          : makeStyle(event)
      }
      ref={drop}
    >
      <div onDoubleClick={() => ondbClick()}>
        <div
          style={
            typeof styleSelector === "function"
              ? styleSelector(event)
              : makeStyle(event)
          }
        >
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
            }}
          >
            <b>{event.name}</b>
          </h5>
        </div>
        <div className={styles.appointmentEventHeader}>
          <h5>{event.name}</h5>

          {detailEnabled && <Details event={event} />}

          {locationEnabled && event.datasheet && event.datasheet.address && (
            <Address
              address={event.datasheet.address}
              className={styles.address}
              multiline
              styles={styles}
            />
          )}
          {locationEnabled && event.customer && event.customer.address && (
            <Address
              address={event.customer.address}
              className={styles.address}
              multiline
              styles={styles}
            />
          )}
          {showEmployees &&
            event.crew.resources.map((e) => {
              if (e.resource !== null) {
                //console.log(e);
                return (
                  <Employee
                    employee={e.resource}
                    key={e.resource.id}
                    color={color}
                    employeeCheck={employeeCheck}
                  />
                );
              }
            })}
        </div>
      </div>
      {showActions && (
        <ActionButtons
          onDeleteEventClick={onDeleteEventClick}
          onEditEventClick={onEditEventClick}
          onOpenClick={onOpenClick}
        />
      )}
    </div>
  );
};

AppointmentEvent.defaultProps = {
  showActions: true,
  locationEnabled: true,
};

export default AppointmentEvent;
